module.exports = __webpack_public_path__ + "img/filter-delete-red.9899216d.svg";